import FeatureLayout from './FeatureLayout';
export default FeatureLayout;